import { DateRangeOption } from '../schema/DateRangeOption';
import { assertNever } from 'owa-assert';
import { OwaDate, endOfDay, startOfMonth, startOfWeek, subDays, subWeeks, now } from 'owa-datetime';
import DateRange from 'owa-range-datepicker/lib/store/schema/DateRange';
import { getUserConfiguration } from 'owa-session-store';

export function getDateRangeForOption(dateRangeOption: DateRangeOption): DateRange | null {
    const date = now();

    switch (dateRangeOption) {
        case DateRangeOption.Month:
            return { startDate: startOfMonth(date), endDate: date };
        case DateRangeOption.Week:
            return { startDate: getStartOfWeek(date), endDate: date };
        case DateRangeOption.CustomDateRange:
            return null;
        case DateRangeOption.LastWeek:
            return {
                startDate: getStartOfLastWeek(date),
                endDate: getEndOfLastWeek(date),
            };
        default:
            return assertNever(dateRangeOption);
    }
}

function getStartOfWeek(date: OwaDate) {
    const userStartOfWeek = getUserConfiguration().UserOptions.WeekStartDay;
    return startOfWeek(date, userStartOfWeek);
}

function getStartOfLastWeek(date: OwaDate) {
    return subWeeks(getStartOfWeek(date), 1);
}

function getEndOfLastWeek(date: OwaDate) {
    return endOfDay(subDays(getStartOfWeek(date), 1));
}
